import React, {
  useEffect,
  useState,
} from "react";
import { useCart }
from "../components/CartContext";

import {
  useParams,
  useNavigate,
} from "react-router-dom";

import axios from "axios";

import "../styles/ProductDetailPage.css";

const ProductDetailPage = () => {

  const { id } = useParams();
  const navigate = useNavigate();

const { addToCart } =
  useCart();

  const [product, setProduct] =
    useState(null);

  const [selectedVariant, setSelectedVariant] =
    useState("");

  const [activeImage, setActiveImage] =
    useState(0);

    
  const [showStickyBar, setShowStickyBar] =
    useState(false);

  /* =========================================
     STICKY BAR
  ========================================= */

  useEffect(() => {

    const handleScroll = () => {

      const heroHeight =
        window.innerHeight * 0.7;

      setShowStickyBar(
        window.scrollY > heroHeight
      );
    };

    window.addEventListener(
      "scroll",
      handleScroll
    );

    return () =>
      window.removeEventListener(
        "scroll",
        handleScroll
      );

  }, []);

  /* =========================================
     FETCH PRODUCT
  ========================================= */

  useEffect(() => {

    const fetchProduct = async () => {

      try {

        const res = await axios.get(
          `https://backend.sacmtb.com/api/products/${id}`
        );

        setProduct(res.data);

      } catch (err) {

        console.log(err);
      }
    };

    fetchProduct();

  }, [id]);

  /* =========================================
     SAFE DATA
  ========================================= */

  const name =
    product?.name || "";

  const discountPrice =
    product?.discountPrice || 0;

  const imageUrls =
    product?.imageUrls || [];

  const category =
    product?.category || "";

  const description =
    product?.description || "";

  const videoUrl =
    product?.videoUrl || "";

  const features =
    product?.features || [];

  const specifications =
    product?.specifications || {};

  const stock =
    product?.stock || 0;

  /* =========================================
     PRODUCT TYPE
  ========================================= */

  const isToy =

  category
    ?.toLowerCase()
    ?.includes("toy");

  const themeClass = isToy

    ? "toyTheme"

    : "bikeTheme";

  /* =========================================
     DYNAMIC CONTENT
  ========================================= */

  const heroTitle =

  product?.heroTitle ||

  (isToy

    ? "BUILT FOR FUN"

    : "BUILT FOR THE WILD");

const heroDescription =

  product?.heroDescription ||

  (isToy

    ? "Premium ride-on toys designed for unforgettable childhood memories."

    : "Designed for riders who seek freedom and aggressive performance.");

  const collectionTitle = isToy

    ? "SAC RIDE ON TOYS"

    : "SAC MTB COLLECTION";

  const cinemaTitle = isToy

    ? "FUN IN EVERY RIDE"

    : "SEE IT FROM EVERY ANGLE";

  const performanceTitle = isToy

    ? "MADE FOR HAPPY KIDS"

    : "ENGINEERED FOR PERFORMANCE";

  const reviewTitle = isToy

    ? "LOVED BY KIDS"

    : "BUILT FOR REAL ADVENTURES";

  const variants =

  product?.sizes?.length

    ? product.sizes.map(
        (item)=>item.size
      )

    : isToy

      ? ["1 Seater"]

      : ["20T"];

  /* =========================================
     DEFAULT VARIANT
  ========================================= */

  useEffect(() => {

    if (
      variants.length > 0 &&
      !selectedVariant
    ) {

      setSelectedVariant(
        variants[0]
      );
    }

  }, [variants, selectedVariant]);

  /* =========================================
     FALLBACK FEATURES
  ========================================= */

  const displayFeatures =

    features?.length

      ? features

      : isToy

        ? [

          {
            title:
              "Battery Powered Ride",

            desc:
              "Smooth and safe electric driving"
          },

          {
            title:
              "LED Headlights",

            desc:
              "Premium realistic styling"
          },

          {
            title:
              "Music & Bluetooth",

            desc:
              "Entertainment while riding"
          },

          {
            title:
              "Parental Remote",

            desc:
              "Parents can safely control"
          }

        ]

        : [

          {
            title:
              "Fat Tyre Grip",

            desc:
              "Maximum road grip"
          },

          {
            title:
              "Dual Disc Brakes",

            desc:
              "Powerful stopping performance"
          },

          {
            title:
              "Front Suspension",

            desc:
              "Smooth riding comfort"
          },

          {
            title:
              "MTB Performance",

            desc:
              "Aggressive off-road design"
          }

        ];

        /* =========================================
   ADD TO CART
========================================= */

const handleAddToCart = () => {

  const cartProduct = {

    _id: product._id,

    name:
      product.heroTitle ||
      product.name,

    fullName:
      product.name,

    price:
      discountPrice,

    image:
      imageUrls?.[0],

    category,

    variant:
      selectedVariant,

    quantity: 1,
  };

  addToCart(cartProduct);

  navigate("/cart");
};
  /* =========================================
     LOADING
  ========================================= */

  if (!product) {

    return (

      <div className="luxury-loading">

        Loading...

      </div>
    );
  }

  return (

    <div
      className={`productDetailPage ${themeClass}`}
    >

      {/* =========================================
         HERO SECTION
      ========================================= */}

      <section className="sac-luxury-hero">

        {/* LEFT VISUAL */}

        <div className="sac-hero-visual">

          <img
            src={imageUrls?.[0]}
            alt={name}
            className="sac-hero-bg-image"
          />

          <div className="sac-dark-overlay"></div>

          {/* CONTENT */}

          <div className="sac-hero-content">

            <span className="sac-small-tag">

              {collectionTitle}

            </span>

            <h1 className="sac-main-title">

              {heroTitle}

            </h1>

            <p className="sac-hero-description">

              {heroDescription}

            </p>

          </div>

        </div>

        {/* BUY BOX */}

        <div className="sac-floating-buybox">

          <div className="sac-buybox-inner">

            {/* PRODUCT IMAGE */}

            <div className="sac-product-image-wrap">

              <img
                src={imageUrls?.[0]}
                alt={name}
                className="sac-product-image"
              />

            </div>

            {/* PRODUCT INFO */}

<h2 className="sac-product-title">

  {product.heroTitle || name}

</h2>

            <p className="sac-product-category">

              {category}

            </p>

            <div className="sac-price-wrap">

  <h3 className="sac-product-price">

    ₹{discountPrice}

  </h3>

  {

    product.price >

    discountPrice && (

      <span className="sac-old-price">

        ₹{product.price}

      </span>
    )
  }

</div>

            {/* VARIANTS */}

            <div className="sac-size-options">

              {variants.map((item) => (

                <button
                  key={item}
                  className={`sac-size-btn ${
                    selectedVariant === item
                      ? "active"
                      : ""
                  }`}
                  onClick={() =>
                    setSelectedVariant(item)
                  }
                >

                  {item}

                </button>

              ))}

            </div>

            {/* BUTTON */}
<button
  className="sac-cart-btn"
  onClick={handleAddToCart}
>

  ADD TO CART

</button>

            {/* FEATURES */}

            <div className="sac-features">

              <div className="sac-feature">
                ✓ Free Delivery
              </div>

              <div className="sac-feature">
                ✓ Premium Quality
              </div>

              <div className="sac-feature">
                ✓ Safe & Durable
              </div>

              <div className="sac-feature">
                ✓ Trusted Brand
              </div>

            </div>

          </div>

        </div>

      </section>

      {/* =========================================
         STICKY BAR
      ========================================= */}

      <div
        className={`sacStickyBar ${
          showStickyBar
            ? "show"
            : "hide"
        }`}
      >

        {/* LEFT */}

        <div className="sacStickyLeft">

          <img
            src={imageUrls?.[0]}
            alt={product.heroTitle || name}
            className="sacStickyImage"
          />

          <div className="sacStickyInfo">

            <h3>{product.heroTitle || name}</h3>

            <span>{category}</span>

          </div>

        </div>

        {/* CENTER */}

        <div className="sacStickyCenter">

          {variants.map((item) => (

            <button
              key={item}
              className={`sacStickySize ${
                selectedVariant === item
                  ? "active"
                  : ""
              }`}
              onClick={() =>
                setSelectedVariant(item)
              }
            >

              {item}

            </button>

          ))}

        </div>

        {/* RIGHT */}

        <div className="sacStickyRight">

          <h2>

            ₹{discountPrice}

          </h2>

         <button
  className="sacStickyCartBtn"
  onClick={handleAddToCart}
>

  ADD TO CART

</button>

        </div>

      </div>

      {/* =========================================
         CINEMA SECTION
      ========================================= */}

      <section className="sacCinemaSection">

        {/* LEFT */}

        <div className="sacCinemaContent">

          <span className="sacCinemaTag">

            {collectionTitle}

          </span>

          <h2 className="sacCinemaTitle">

            {cinemaTitle}

          </h2>

          <p className="sacCinemaDesc">

            {description}

          </p>

        </div>

        {/* RIGHT */}

        <div className="sacCinemaVisual">

          {/* VIDEO */}

          <video
            autoPlay
            muted
            loop
            playsInline
            className="sacCinemaVideo"
          >

            <source
              src={
                videoUrl ||
                "/videos/demo.mp4"
              }
              type="video/mp4"
            />

          </video>

          <div className="sacCinemaOverlay"></div>

          <div className="sacBikeGlow"></div>

          {/* PRODUCT */}

          <img
            src={
              imageUrls?.[
                activeImage
              ] || imageUrls?.[0]
            }
            alt={name}
            className="sacFloatingBike"
          />

          {/* THUMBNAILS */}

          <div className="sacMiniSelectors">

            {(imageUrls || []).map(
              (img, index) => (

              <button
                key={index}
                className={`sacMiniBtn ${
                  activeImage === index
                    ? "active"
                    : ""
                }`}
                onClick={() =>
                  setActiveImage(index)
                }
              >

                <img
                  src={img}
                  alt=""
                />

              </button>

            ))}

          </div>

        </div>

      </section>

      {/* =========================================
         FEATURES + SPECS
      ========================================= */}

      <section className="sacSpecsSection">

        {/* LEFT */}

        <div className="sacSpecsLeft">

          <span className="sacSpecsTag">

            PERFORMANCE

          </span>

          <h2 className="sacSpecsTitle">

            {performanceTitle}

          </h2>

          <p className="sacSpecsDesc">

            {description}

          </p>

        </div>

        {/* FEATURES */}

        <div className="sacFeaturesGrid">

          {displayFeatures.map(
            (feature, index) => (

            <div
              className="sacFeatureCard"
              key={index}
            >

              <span className="sacFeatureIcon">

                ✦

              </span>

              <h3>

                {feature.title}

              </h3>

              <p>

                {feature.desc}

              </p>

            </div>

          ))}

        </div>

        {/* SPECIFICATIONS */}

        <div className="sacSpecsGrid">

          {Object.entries(

            Object.keys(
              specifications
            ).length

              ? specifications

              : {

                Category:
                  category,

                Price:
                  `₹${discountPrice}`,

                Stock:
                  stock,
              }

          ).map(([key, value], index) => (

            <div
              className="sacSpecItem"
              key={index}
            >

              <span>{key}</span>

              <strong>{value}</strong>

            </div>

          ))}

        </div>

      </section>

      {/* =========================================
         REVIEWS
      ========================================= */}

      <section className="sacReviewSection">

        <div className="sacReviewHeading">

          <span>

            CUSTOMER STORIES

          </span>

          <h2>

            {reviewTitle}

          </h2>

        </div>

        <div className="sacReviewGrid">

          {[1, 2, 3].map((item) => (

            <div
              className="sacReviewCard"
              key={item}
            >

              <div className="sacReviewStars">

                ★★★★★

              </div>

              <p>

                {isToy

                  ? "My child absolutely loves this ride-on toy. Amazing quality and smooth ride."

                  : "This bike completely changed my riding experience. Premium feel and aggressive performance."
                }

              </p>

              <div className="sacReviewUser">

                <img
                  src="https://i.pravatar.cc/100"
                  alt=""
                />

                <div>

                  <h4>

                    Customer {item}

                  </h4>

                  <span>

                    Verified Buyer

                  </span>

                </div>

              </div>

            </div>

          ))}

        </div>

      </section>

    </div>
  );
};

export default ProductDetailPage;